import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { updateSellerShipFroms } from '../../../store/seller/seller.actions';
import { getShipFroms } from './api';

const useFetchShipFroms = () => {
  const dispatch = useDispatch();

  const fetchShipFroms = useCallback(async () => {
    const result = await getShipFroms();
    dispatch(updateSellerShipFroms(result));
  }, [dispatch]);

  return useMemo(
    () => ({
      fetchShipFroms,
    }),
    [fetchShipFroms],
  );
};

export default useFetchShipFroms;
